<template>
	<svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="13" y="13" width="34" height="34" fill="white" />
	</svg>
</template>
